// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"296c012e","251":"55443f30","348":"0ed35cb7","571":"af3225ac"}[chunkId] + ".chunk.js";
};